import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // Start with 2 hours, 45 minutes, 30 seconds
  const [timeLeft, setTimeLeft] = useState(2 * 3600 + 45 * 60 + 30);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center space-x-2 text-2xl md:text-4xl font-bold font-mono bg-[#112240] py-4 px-6 rounded-xl border border-[#d4a843]/30 shadow-[0_0_15px_rgba(212,168,67,0.15)]" data-id="element-73">
      <div className="flex flex-col items-center" data-id="element-74">
        <span className="text-white" data-id="element-75">{format(hours)}</span>
        <span className="text-[10px] text-slate-400 font-sans uppercase tracking-wider mt-1" data-id="element-76">
          hs
        </span>
      </div>
      <span className="text-[#d4a843] pb-5" data-id="element-77">:</span>
      <div className="flex flex-col items-center" data-id="element-78">
        <span className="text-white" data-id="element-79">{format(minutes)}</span>
        <span className="text-[10px] text-slate-400 font-sans uppercase tracking-wider mt-1" data-id="element-80">
          min
        </span>
      </div>
      <span className="text-[#d4a843] pb-5" data-id="element-81">:</span>
      <div className="flex flex-col items-center" data-id="element-82">
        <span className="text-[#d4a843]" data-id="element-83">{format(seconds)}</span>
        <span className="text-[10px] text-[#d4a843]/70 font-sans uppercase tracking-wider mt-1" data-id="element-84">
          seg
        </span>
      </div>
    </div>;
}